// Copyright (c) 2021 Proto Labs, Inc. All Rights Reserved.

import { createRouter, createWebHistory } from 'vue-router';
import headerComp from '@/components/Header.vue';
import uploadComp from '@/components/UploadComponent.vue';

const router = createRouter({
	history: createWebHistory(process.env.SELF_URL),
	routes: [
		{
			path: '/',
			name: 'App',
			redirect: '/upload',
		},
		{
			path: '/upload',
			name: 'Upload',
			meta: { title: 'Upload Document' },
			components: {
				header: headerComp,
				default: uploadComp,
			},
		},
	],
});

export default router;
